import type { ActivitySourceName } from '../types/activity-source'
import type { ActivitySource } from './activity-source'

export class ActivityRegistry {
  private static sources = new Map<ActivitySourceName, ActivitySource>()
  static isActive = false

  static register(source: ActivitySource): void {
    source.subscribe(() => {
      ActivityRegistry.isActive = true
    })
    ActivityRegistry.sources.set(source.name, source)
  }

  static unregister(name: ActivitySourceName): void {
    ActivityRegistry.sources.get(name)?.unsubscribe()
    ActivityRegistry.sources.delete(name)
  }

  static reset(): void {
    ActivityRegistry.isActive = false
  }

  static clear(): void {
    for (const name of ActivityRegistry.sources.keys()) {
      ActivityRegistry.unregister(name)
    }
    ActivityRegistry.reset()
  }
}
